import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/logos/Min_LVVN_Logo.png")